<template>
  <div class="view-layout">
    <m-widget-head class="content-widget-head">
      <div class="status-filter flex">
        <active-button :active="filter === 'all'" @click="changeFilter('all')">{{ $t('account.bets.filter.all') }}</active-button>
        <active-button :active="filter === 'open'" @click="changeFilter('open')">{{ $t('account.bets.filter.open') }}</active-button>
        <active-button :active="filter === 'winning'" @click="changeFilter('winning')">{{ $t('account.bets.filter.winning') }}</active-button>
        <active-button :active="filter === 'losing'" @click="changeFilter('losing')">{{ $t('account.bets.filter.losing') }}</active-button>
        <active-button :active="filter === 'refund'" @click="changeFilter('refund')">{{ $t('account.bets.filter.refund') }}</active-button>
      </div>
      <template slot="right">
        <div class="date-range">
          <div class="caption">{{ $t('common.date-range.from') }}</div>
          <date-button :date="$route.params.from" @change="followFrom" />
          <div class="caption">{{ $t('common.date-range.to') }}</div>
          <date-button :date="$route.params.to" @change="followTo" />
        </div>
      </template>
    </m-widget-head>
    <div class="content-layout">
      <m-scrollbar>
        <bet-list />
      </m-scrollbar>
    </div>
  </div>
</template>

<script>
import MWidgetHead from '@/components/widget/MWidgetHead'
import MScrollbar from '@/components/MScrollbar'
import ActiveButton from '@/components/buttons/ActiveButton'
import DateButton from '@/components/buttons/DateButton'
import BetList from '@/components/account/bets/List'
import { mapState } from 'vuex'

export default {
  components: {
    MWidgetHead,
    MScrollbar,
    ActiveButton,
    DateButton,
    BetList
  },
  computed: {
    ...mapState({
      filter: state => state.account.bets.filter
    })
  },
  mounted () {
    this.dispatchFollow()
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.dispatchFollow()
    }
  },
  methods: {
    followFrom (date) {
      this.$router.push(`/account/bets/from/${date}/to/${this.$route.params.to}`)
      this.dispatchFollow()
    },
    followTo (date) {
      this.$router.push(`/account/bets/from/${this.$route.params.from}/to/${date}`)
      this.dispatchFollow()
    },
    dispatchFollow () {
      this.$store.dispatch('account/GET_BETS', {
        params: {
          from: this.$route.params.from,
          to: this.$route.params.to
        }
      })
    },
    changeFilter (value) {
      this.$store.commit('account/SET_BET_FILTER', value)
    }
  }
}
</script>

<style scoped>
.view-layout { height: 100%; }
.content-layout { height: 100%; margin-top: -40px; padding: 50px 0 10px; background: white; }
.content-widget-head { margin: 0 10px; }

.status-filter .active-button { height: 40px; line-height: 40px; padding: 0 10px; }

.date-range { display: flex; }
.date-range .caption { font-size: 14px; }
</style>



// WEBPACK FOOTER //
// src/components/account/bets/View.vue